import React, { useCallback } from 'react'
import { IPendingResourceAuthorization } from '@verzekeringapp-mono/shared/src/models/resource_authorization'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useUser from '@verzekeringapp-mono/shared/src/hooks/use_user'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'

const PendingUserCard = (resourceAuthorization: IPendingResourceAuthorization) => {
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)
  const { deleteInvite } = useUser()

  const deleteInvitedUser = useCallback(() => {
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber

    if (!relationNumber) {
      alert('Er is een fout opgetreden bij het verwijderen van de gebruiker. Probeer het later opnieuw.')

      return
    }

    deleteInvite(relationNumber, resourceAuthorization.token).then(() => {
      window.location.reload()
    }).catch((err) => {
      alert(err?.message || 'Er is een fout opgetreden bij het verwijderen van de gebruiker. Probeer het later opnieuw.')
    })
  }, [resourceAuthorization.token, currentResourceAuthorization?.relationInfo?.relationNumber])

  return (
    <div
      key={resourceAuthorization.combiNumber}
      className='mt-4 flex flex-wrap items-center justify-between rounded-md border border-border-warning bg-status-warning-subtle p-4'
    >
      <div>
        <p className='font-semibold'>
          {'Uitgenodigde gebruiker'}
        </p>

        <p>{resourceAuthorization.email}</p>

        <p>{resourceAuthorization.combiNumber}</p>
      </div>

      <div>
        <div className='flex gap-4'>
          <button
            type='button'
            className='text-icon-muted hover:text-status-danger-foreground'
            onClick={e => {
              e.preventDefault()
              const isConfirmed = confirm(
                'Weet je zeker dat je deze uitgenodigde gebruiker wilt verwijderen?'
              )

              if (isConfirmed) {
                deleteInvitedUser()
              }
            }}
          >
            <FontAwesomeIcon
              icon={faTrash}
              size='lg'
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default PendingUserCard
